import { AbcdeRiskValue, ensureGradedRiskValue } from "@/features/risk_bands";
import { RiskBandsRiskValue } from "@/store/services/facades/types";
import { SingleLetterRiskBand } from "./SingleLetterRiskBand";
import { WordyRiskBand } from "./WordyRiskBand";
export const RISK_BAND_COLOURS: Record<AbcdeRiskValue, string> = {
  A: "#56BD5C",
  B: "#F4C747",
  C: "#D6305A",
  D: "#000",
  E: "#df0000"
};

/**
 * External-facing components.
 */

export interface RiskBandProps {
  rating?: RiskBandsRiskValue | null | any;
  size?: number;
  showAsWordy?: boolean;
  notApplicable?: boolean;
}
export const RiskBand = ({
  rating,
  size = 120,
  showAsWordy = false,
  notApplicable = false
}: RiskBandProps) => {
  const grade = rating ? ensureGradedRiskValue(rating) : "?";
  const colour = grade === "?" ? "#777" : RISK_BAND_COLOURS[grade];
  return showAsWordy ? <WordyRiskBand colour={colour} rating={grade} size={size} data-sentry-element="WordyRiskBand" data-sentry-component="RiskBand" data-sentry-source-file="RiskBand.tsx" /> : <SingleLetterRiskBand rating={grade} size={size} notApplicable={notApplicable} data-sentry-element="SingleLetterRiskBand" data-sentry-component="RiskBand" data-sentry-source-file="RiskBand.tsx" />;
};
export interface RiskBandWithLabelProps extends RiskBandProps {
  label: string;
  labelFontSize?: string;
}
export const RiskBandWithLabel = ({
  labelFontSize,
  label,
  ...props
}: RiskBandWithLabelProps) => {
  return <div className="flex flex-col items-center justify-center" data-sentry-component="RiskBandWithLabel" data-sentry-source-file="RiskBand.tsx">
      <RiskBand {...props} data-sentry-element="RiskBand" data-sentry-source-file="RiskBand.tsx" />
      <div className="font-medium" style={{
      fontSize: labelFontSize
    }}>
        {label}
      </div>
    </div>;
};